<template>
  <div class="footer-bottom">
    <div class="footer-bottom__container">
      <div class="footer-bottom__year">{{ `© On ${new Date().getFullYear()}` }}</div>
      <FooterSocial v-if="!isDesktop" class="footer-bottom__social" />
    </div>
    <FooterAdditionalLinks v-if="isDesktop" @navigation="reportNavigation" />
    <FooterLocale
      class="footer-bottom__locale"
      @overlay-state-change="$emit('overlay-state-change', $event)"
    />
  </div>
</template>

<script>
import FooterLocale from './FooterLocale.vue'
import FooterSocial from '@/components/Footer/FooterSocial.vue'
import FooterAdditionalLinks from '@/components/Footer/FooterAdditionalLinks.vue'

export default {
  name: 'FooterBottom',
  components: { FooterAdditionalLinks, FooterLocale, FooterSocial },
  props: { isDesktop: Boolean },

  methods: {
    reportNavigation(link) {
      this.$emit('navigation', link)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './footer-settings';

$border-style: 1px solid $c-grey-dark-3;

.footer-bottom {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding: 20px 0 0;

  @media (min-width: $mobile-bp) {
    margin-top: 40px;
    padding: 22px 0;
    border-top: $border-style;
    flex-direction: row;
  }

  @media ($mq-larger) {
    margin-top: 8px;
  }

  @media ($mq-full) {
    margin-top: 40px;
  }

  &__container {
    display: flex;
    order: 2;
    padding: 18px 0 16px;
    border-top: $border-style;

    @media (min-width: $mobile-bp) {
      position: relative;
      top: 2px;
      padding: 0;
      min-width: 160px;
      border-top: none;
    }

    @media ($mq-high) {
      min-width: $left-column-width-high;
    }
  }

  &__year {
    flex: 1;
    padding-top: 2px;
    font-weight: 500;
    font-size: $f-size-smaller;
    line-height: 1.5;

    @media (min-width: $mobile-bp) {
      position: relative;
      left: 35px;
      order: 1;
      padding: 0;
    }

    @media (min-width: 1650px) {
      left: 0;
    }
  }

  &__locale {
    flex: 1;
    order: 1;
    min-width: 200px;
    padding-bottom: 20px;

    @media (min-width: $mobile-bp) {
      position: relative;
      top: -2px;
      order: 3;
      padding: 0;
      font-size: $f-size-small;
      text-align: right;
    }
  }
}
</style>
